module.exports = __webpack_public_path__ + "img/14.a0b54ed1.jpg";